import styled from 'styled-components';

import { ModalContent } from '../../styles';

const StyledModalContent = styled(ModalContent)`
  padding-left: 15px;
`;

const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: calc(100% + 15px);
  margin-left: -15px;
  text-align: center;
`;

export {
  EmptyStateContainer,
  StyledModalContent,
};
